import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import * as appTagActions from "../../actions/appTags";

export function useAppTagStore() {
  const dispatch = useDispatch();
  const _appTags = useSelector((store) => store.appTags);

  const fetchAppTags = useCallback(
    async () => await dispatch(appTagActions.fetchAppTags()),
    [dispatch]
  );

  const updateAppTag = useCallback(
    async (type, tag, isDelete) =>
      await dispatch(appTagActions.updateAppTag(type, tag, isDelete)),
    [dispatch]
  );

  const refreshTags = useCallback(
    async (type, uuid) => await dispatch(appTagActions.refreshTags(type, uuid)),
    [dispatch]
  );

  return {
    appTags: _appTags,
    fetchAppTag: fetchAppTags,
    refreshTags,
    updateAppTag,
  };
}
